import { getStreamTicketFRService } from '../../service/face_recognition/FaceRecognitionService';

/**
 * Gestión del ticket de acceso a /faceRecognition/stream y /snapshot.
 *
 * Esos dos endpoints los consume el navegador con EventSource y con <img src>,
 * que no pueden enviar la cabecera Authorization. En vez de exponer el JWT de
 * sesión en la URL —donde quedaría en logs, historial y Referer— se canjea por
 * un ticket de 5 minutos con alcance limitado a esos dos recursos de lectura.
 *
 * La caché es de módulo, así que las dos pantallas de Face Recognition comparten
 * el mismo ticket y no piden uno por cada componente.
 */
let _ticket: string | null = null;
let _expiraEn = 0;

/** Margen para renovar antes de que expire y evitar una carrera en el límite. */
const MARGEN_MS = 60000;

export async function obtenerTicket(token: string, forzar = false): Promise<string> {
  const ahora = Date.now();
  if (!forzar && _ticket && _expiraEn - ahora > MARGEN_MS) return _ticket;

  const { ticket, expiresIn } = await getStreamTicketFRService(token);
  _ticket = ticket;
  _expiraEn = ahora + expiresIn * 1000;
  return ticket;
}

export function invalidarTicket(): void {
  _ticket = null;
  _expiraEn = 0;
}

/** Agrega el ticket a una URL, respetando si ya trae query string. */
export function conTicket(url: string, ticket: string): string {
  if (!ticket) return url;
  return `${url}${url.includes('?') ? '&' : '?'}ticket=${encodeURIComponent(ticket)}`;
}
